import enhancer from './enhancers/profile'
import Profile from './Profile'

export default enhancer(Profile)
